import { getPublicationsRequest } from 'api/Publications/api';
import { PublicationsResponse } from 'api/Publications/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { useCallback, useState } from 'react';

const usePublications = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>();
  const [ publications, setPublications ] = useState<PublicationsResponse>({
    meta: { totalCount: 0 },
    items: [],
    allTags: [],
  });

  const fetchPublications = useCallback((sortBy: string | null, search: string, abortController: AbortController) => {
    setIsLoading(true);
    setError(undefined);

    getPublicationsRequest(sortBy, search, abortController)
      .then(({ data }) => {
        setPublications(data);
      })
      .catch((reason) => {
        if (!abortController.signal.aborted) {
          setError(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, []);

  return { publications, isLoading, error, fetchPublications };
};

export default usePublications;
